import PortfolioAssessmentContainer from "./containers/PortfolioAssessmentContainer";
import "./SCSS/styles.css";
export default PortfolioAssessmentContainer;
